import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { IconButton, Menu, MenuItem } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";

export default function ProfileMenu() {
  const [menuAchor, setMenuAnchor] = React.useState<
    null | (EventTarget & HTMLButtonElement)
  >(null);

  return (
    <>
      <IconButton
        color="inherit"
        onClick={(e) => setMenuAnchor(e.currentTarget)}
      >
        <AccountCircleIcon />
      </IconButton>
      <Menu
        anchorEl={menuAchor}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        open={Boolean(menuAchor)}
        onClose={() => setMenuAnchor(null)}
      >
        <div style={styles.userNameDiv}>
          {JSON.parse(localStorage.getItem("user") || "").userName}
        </div>
        <hr />
        <MenuItem
          component={Link}
          to="/account"
          onClick={() => setMenuAnchor(null)}
        >
          Account
        </MenuItem>
        <MenuItem
          component="a"
          href="https://drive.google.com/drive/folders/1G4X9UWpUoHkwykdliEQBcQFONaagEP4x"
          target="_blank"
          rel="noopener"
          onClick={() => setMenuAnchor(null)}
        >
          Catalog
        </MenuItem>
        <MenuItem
          onClick={() => {
            localStorage.removeItem("user");
            setMenuAnchor(null);
            window.location.reload();
          }}
        >
          Log out
        </MenuItem>
      </Menu>
    </>
  );
}

type Styles = Record<string, React.CSSProperties>;

const styles: Styles = {
  userNameDiv: {
    fontWeight: "bold",
    textAlign: "center",
    marginTop: "5px",
    marginBottom: "13px",
    paddingLeft: "10px",
    paddingRight: "10px",
  },
};
